/**
 * IA Color Cards â€” Expand multi-color products into separate cards per color
 * Each color variant gets its own card in the collection grid with:
 * - The variant's image as the card image
 * - Link to product page with ?variant=ID to pre-select that color
 * - Only that color's swatch highlighted
 * - Same pricing, stock info, style number
 */
(function () {
  'use strict';

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;

    items.forEach(function (li) {
      var swatches = li.querySelectorAll('.color-swatch .swatch');
      if (swatches.length <= 1) return; // Single or no colors â€” skip

      var cardLink = li.querySelector('.card a.full-unstyled-link');
      var cardImg = li.querySelector('.card img.motion-reduce');
      if (!cardImg || !cardLink) return;

      var originalHref = cardLink.getAttribute('href');
      var originalSrc = cardImg.getAttribute('src');
      var originalSrcset = cardImg.getAttribute('srcset') || '';

      // First swatch is already showing â€” handle remaining swatches
      for (var i = 1; i < swatches.length; i++) {
        var swatch = swatches[i];
        var variantId = swatch.getAttribute('data-id');
        var variantImgUrl = swatch.getAttribute('data-url');
        if (!variantImgUrl) continue; // No image for this color â€” skip

        // Clone the entire <li>
        var clone = li.cloneNode(true);

        // Update the main card image
        var cloneImg = clone.querySelector('.card img.motion-reduce');
        if (cloneImg) {
          cloneImg.setAttribute('src', variantImgUrl);
          cloneImg.setAttribute('srcset', '');
          cloneImg.removeAttribute('data-srcset');
          // Remove secondary hover image
          var secondaryImg = clone.querySelector('.card img.motion-reduce + img');
          if (secondaryImg) secondaryImg.remove();
        }

        // Update all card links to include ?variant=ID
        var cloneLinks = clone.querySelectorAll('a');
        cloneLinks.forEach(function (a) {
          var href = a.getAttribute('href');
          if (href && href.indexOf('/products/') !== -1) {
            a.setAttribute('href', href.split('?')[0] + '?variant=' + variantId);
          }
        });

        // Highlight only this color's swatch
        var cloneSwatches = clone.querySelectorAll('.color-swatch .swatch');
        cloneSwatches.forEach(function (s, idx) {
          if (idx === i) {
            s.style.border = '2px solid #000';
            s.style.boxShadow = '0 0 0 1px #fff, 0 0 0 2px #000';
          } else {
            s.style.opacity = '0.4';
            s.style.border = '1px solid #ccc';
          }
        });

        // Remove animation delay from clone
        clone.style.removeProperty('--animation-order');
        clone.classList.remove('scroll-trigger', 'animate--slide-in');

        // Insert after the original
        li.parentNode.insertBefore(clone, li.nextSibling);
      }

      // For the original card, highlight the first swatch
      swatches[0].style.border = '2px solid #000';
      swatches[0].style.boxShadow = '0 0 0 1px #fff, 0 0 0 2px #000';
      for (var j = 1; j < swatches.length; j++) {
        swatches[j].style.opacity = '0.4';
        swatches[j].style.border = '1px solid #ccc';
      }

      // Update original card link to include first variant
      var firstVariantId = swatches[0].getAttribute('data-id');
      if (firstVariantId) {
        var allLinks = li.querySelectorAll('a');
        allLinks.forEach(function (a) {
          var href = a.getAttribute('href');
          if (href && href.indexOf('/products/') !== -1 && href.indexOf('variant=') === -1) {
            a.setAttribute('href', href.split('?')[0] + '?variant=' + firstVariantId);
          }
        });
      }
    });

    // Update product count display
    var newCount = grid.querySelectorAll(':scope > li.grid__item').length;
    var countEls = document.querySelectorAll('#ProductCount, #ProductCountDesktop');
    countEls.forEach(function (el) {
      el.textContent = newCount + ' products';
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after infinite scroll loads new products
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) {
        // Debounce
        clearTimeout(window._iaColorCardsTimer);
        window._iaColorCardsTimer = setTimeout(init, 200);
      }
    });
  });
  var grid = document.getElementById('product-grid');
  if (grid) {
    observer.observe(grid, { childList: true });
  }
})();
